// extracted by mini-css-extract-plugin
module.exports = {"TabsContainer":"Tabs_TabsContainer__1dwyM","Tab":"Tabs_Tab__3JKsN","Active":"Tabs_Active__2UYIV","unseenCount":"Tabs_unseenCount__299vL"};